import { Http } from '@material-ui/icons';
import Axios from 'axios'
import { PermissionAccessLevel, PermissionType } from '../common/types';
import store from './appStore';


let currentToken: string = '';

interface IHeaders {
    "Access-Control-Allow-Origin"?: string,
    "Access-Control-Allow-Headers"?: string,
    Accept: string,
    Authorization?: string
}

export interface ILoginResult {
    token: string | null,
    result: number | null,
    newDevice: boolean | null,
    newDeviceToken: string | null
}

export interface IUserAddUpdateResult {
    userId: string | null,
    emailAddress: string | null,
    message: string | null,
    hasError: boolean | null,
    password: string | null,
    currentPassword: string | null
}

export interface IUserProfileAddUpdateResult {
    userProfileId: string | null,
    name: string | null,
    message: string | null,
    hasError: boolean | null
}

export interface IWardAddUpdateResult {
    wardId: string | null,
    name: string | null,
    shortName: string | null,
    message: string | null,
    hasError: boolean | null
}

export interface ICustomerAddUpdateResult {
    customerId: string | null,
    emailAddress: string | null,
    message: string | null,
    hasError: boolean | null
}

export interface ILocationAddUpdateResult {
    locationId: string | null,
    name: string | null,
    shortName: string | null,
    customerId: string | null,
    type: number | null,
    monFrom: string | null,
    monTo: string | null,
    tueFrom: string | null,
    tueTo: string | null,
    wedFrom: string | null,
    wedTo: string | null,
    thursFrom: string | null,
    thursTo: string | null,
    friFrom: string | null,
    friTo: string | null,
    satFrom: string | null,
    satTo: string | null,
    sunFrom: string | null,
    sunTo: string | null,
    clusterId: string | null
}

interface IAddBooking {
    "firstname": string | null,
    "lastname": string | null,
    "bday": number | null,
    "bmonth": number | null,
    "byear": number | null,
    "IsIdentifiedAsIndegennous": number | null,
    "MRN": string | null,
    "genderName": string | null,
    "classificationName": string | null,
    "MobilityName": string | null,
    "weight": number | null,
    "GirthIsOver90CM": boolean | null,
    "AnyTimeOfTheDay": boolean | null,
    "ReasonForThisTime": 1 | null,
    "OtherReasonDetails": string | null,
    "PatientHasNoAllegies": boolean | null,
    "PatientAllergies": string | null,
    "PatientHasNoMedicalConditions": boolean | null,
    "PatientMedicalConditions": string | null,
    "PickupBeforeTime": string | null,
    "PickupAfterTime": string | null,
    "DropoffBeforeTime": string | null,
    "DropoffAfterTime": string | null,
    "BookingSpecialNeeds": Array<object> | null,
    "Observations": Array<object> | null,
    "MedicalConditions": Array<object> | null,
    "Transfers": Array<object> | null,
}

export interface ILocationClusterAddUpdateResult {
    locationClusterId: string | null,
    name: string | null,
    message: string | null,
    hasError: boolean | null
}

export interface IVehicleAddUpdateResult {
    vehicleId: string | null,
    baseId: string | null,
    callSign: string | null,
    noOfAttendantSeats: number | null,
    noOfStretchers: number | null,
    acuity: number | null,
    suitableForHealthshare: boolean | null,
    message: string | null
}

let storeIsReady = false;

const located = window.location;
const apiUrl = `${located.protocol}//${located.hostname}${(located.port ? ':' + located.port : '')}/api/`;

const stHeaders: IHeaders = {
    //"Access-Control-Allow-Origin": "*",
    //"Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept, Authorization,Accept-Encoding"
    'Accept': "application/json"
    
};

const HTTP = createAxios();


function createAxios() {
    const headers: IHeaders = { ...stHeaders };
    const token = currentToken;
    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }

    const axios = Axios.create({
        headers: headers,
        baseURL: apiUrl
    });

    axios.interceptors.request.use(
        conf => {
            return conf;
        },
        error => {
            return Promise.reject(error);
        }
    );
    axios.interceptors.response.use(
        response => {
            return response;
        },
        error => {
            if (error.response && error.response.status && (error.response.status === 401 || error.response.status === 403)) {
                window.location.replace("/login");
            }
            return Promise.reject(error);
        }
    );
    return axios;
}

export default {
    getToken(): string {

        return currentToken;
    },
    setToken: (newToken: string): void => {
        currentToken = newToken;
        HTTP.defaults.headers['Authorization'] = `Bearer ${currentToken}`;
    },
    login: async (query: string, data: any): Promise<ILoginResult> => {
        const res = await HTTP.post<ILoginResult>(`Auth/Login${query ? "?" + query : ""}`, data);
        return res.data;
    },
    logout: async (query: string, data: any): Promise<ILoginResult> => {
        const res = await HTTP.post<ILoginResult>(`Auth/Logout${query ? "?" + query : ""}`, data);
        return res.data;
    },
    setSessionExpired: async (query: string, data: any): Promise<ILoginResult> => {
        const res = await HTTP.post<ILoginResult>(`Auth/SetSessionExpired${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getSignup: (query: string) => {
        return HTTP.get(`SignUp/GetSignUp${query ? "?" + query : ""}`);
    },
    signup: (query: string, data: any) => {
        return HTTP.post(`SignUp/SignUp${query ? "?" + query : ""}`, data);
    },
    requestEmailChangeDuringSignUp: (query: string, data: any) => {
        return HTTP.post(`SignUp/RequestChangeEmail${query ? "?" + query : ""}`, data);
    },
    validateEmailChangeDuringSignUp: (query: string, data: any) => {
        return HTTP.post(`SignUp/ValidateEmailConfirmationCode${query ? "?" + query : ""}`, data);
    },
    validateEmailUniqueDuringSignUp: (query: string, data: any) => {
        return HTTP.post(`SignUp/ValidateEmailUnique${query ? "?" + query : ""}`, data);
    },
    getAddUserData: (query: string) => {
        return HTTP.get(`User/AddUser${query ? "?" + query : ""}`);
    },
    getEditUserData: (query: string) => {
        return HTTP.get(`User/EditUser${query ? "?" + query : ""}`);
    },
    searchUsersByName: (query: string) => {
        return HTTP.get(`User/GetUsersWithSearch${query ? "?" + query : ""}`);
    },
    GetUserProfile: (query: string) => {
        return HTTP.get(`User/GetUserProfile${query ? "?" + query : ""}`);
    },
    getLocations: (query: string) => {
        return HTTP.get(`Location/GetLocations${query ? "?" + query : ""}`);
    },
    getWardsInLocation: (query: string) => {
        return HTTP.get(`Ward/GetWardsByLocation${query ? "?" + query : ""}`);
    },
    getLocationsPerCustomer: (query: string) => {
        return HTTP.get(`Location/GetLocationsByCustomer${query ? "?" + query : ""}`);
    },
    generatePassword: (query: string) => {
        return HTTP.get(`User/GeneratePassword${query ? "?" + query : ""}`);
    },
    addNewUser: async (query: string, data: any): Promise<IUserAddUpdateResult> => {
        const res = await HTTP.post<IUserAddUpdateResult>(`User/AddNewUser${query ? "?" + query : ""}`, data);
        return res.data;
    },
    updateUser: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<IUserAddUpdateResult>(`User/UpdateUser${query ? "?" + query : ""}`, data);
        return res.data;
    },
    changePassword: async (query: string, data: any): Promise<IUserAddUpdateResult> => {
        const res = await HTTP.post<IUserAddUpdateResult>(`User/ChangePassword${query ? "?" + query : ""}`, data);
        return res.data;
    },
    unLockUser: async (query: string, data: any): Promise<IUserAddUpdateResult> => {
        const res = await HTTP.post<IUserAddUpdateResult>(`User/UnLockUser${query ? "?" + query : ""}`, data);
        return res.data;
    },
    resendInvitationLink: async (query: string, data: any): Promise<IUserAddUpdateResult> => {
        const res = await HTTP.post<IUserAddUpdateResult>(`User/ResendInvitationLink${query ? "?" + query : ""}`, data);
        return res.data;
    },
    generateResetPasswordRequest: async (query: string, data: any): Promise<IUserAddUpdateResult> => {
        const res = await HTTP.post<IUserAddUpdateResult>(`User/GenerateResetPasswordRequest${query ? "?" + query : ""}`, data);
        return res.data;
    },
    validateResetPasswordRequest: async (query: string) => {
        const res = await HTTP.get(`User/IsPasswordRequestValid${query ? "?" + query : ""}`);
        return res.data;
    },
    resetPassword: async (query: string, data: any) => {
        const res = await HTTP.post(`User/ResetPassword${query ? "?" + query : ""}`, data);
        return res.data;
    },  
    checkLoginOTP: async (query: string, data: any): Promise<ILoginResult> => {
        const res = await HTTP.post<ILoginResult>(`Auth/CheckLoginOTP${query ? "?" + query : ""}`, data);
        return res.data;
    },    
    addProfile: async (query: string, data: any): Promise<IUserProfileAddUpdateResult> => {
        const res = await HTTP.post<IUserProfileAddUpdateResult>(`User/AddNewUserProfile${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getProfilePermissions: async (query: string) => {
        return await HTTP.get(`User/GetUserProfilePermissions${query ? "?" + query : ""}`);
    },
    saveProfilePermissions: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<IUserProfileAddUpdateResult>(`User/UpdateUserProfilePermissions${query ? "?" + query : ""}`, data);
        return res.data;
    },
    saveuserprofie: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<IUserProfileAddUpdateResult>(`User/UpdateUserProfile${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getProfileAllowedPermissions: async (query: string) => {
        return await HTTP.get(`User/GetProfileAllowedPermissions${query ? "?" + query : ""}`);
    },
    getUsermanageuser: async (query: string) => {
        return await HTTP.get(`User/GetUsermanageuser${query ? "?" + query : ""}`);
    },
    deleteUserProfile: async (query: string): Promise<any> => {
        const res = await HTTP.post<IUserProfileAddUpdateResult>(`User/DeleteUserProfile${query ? "?" + query : ""}`);
        return res.data;
    },
    getAddWardData: (query: string) => {
        return HTTP.get(`Ward/AddWard${query ? "?" + query : ""}`);
    },
    getEditWardData: (query: string) => {
        return HTTP.get(`Ward/EditWard${query ? "?" + query : ""}`);
    },
    addNewWard: async (query: string, data: any): Promise<IWardAddUpdateResult> => {
        const res = await HTTP.post<IWardAddUpdateResult>(`Ward/AddNewWard${query ? "?" + query : ""}`, data);
        return res.data;
    },
    updateWard: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<IWardAddUpdateResult>(`Ward/UpdateWard${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getEditCustomerdData: (query: string) => {
        return HTTP.get(`Customer/EditCustomer${query ? "?" + query : ""}`);
    },
    addNewCustomer: async (query: string, data: any): Promise<ICustomerAddUpdateResult> => {
        const res = await HTTP.post<ICustomerAddUpdateResult>(`Customer/AddNewCustomer${query ? "?" + query : ""}`, data);
        return res.data;
    },
    updateCustomer: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<ICustomerAddUpdateResult>(`Customer/UpdateCustomer${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getCustomers: (query: string) => {
        return HTTP.get(`Customer/GetCustomers${query ? "?" + query : ""}`);
    },
    getCustomersWithSearch: (query: string) => {
        return HTTP.get(`Customer/GetCustomersWithSearch${query ? "?" + query : ""}`);
    },   
    GetAndSearchLocations: (query: string) => {
        return HTTP.get(`Location/GetLocationsWithSearch${query ? "?" + query : ""}`);
    },
    getAddEditLocationLoadData: async (query: string): Promise<any> => {
        return HTTP.get(`Location/AddLocation${query ? "?" + query : ""}`);
        // const res = await HTTP.post(`Location/AddLocation${query ? "?" + query : ""}`, data);
        // return res.data;
    },
    addNewLocation: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<ILocationAddUpdateResult>(`Location/AddNewLocation${query ? "?" + query : ""}`, data);
        return res.data;
    },
    addSharedtrip: async (query: string): Promise<any> => {
        const res = await HTTP.post(`Location/AddSharedtrip${query ? "?" + query : ""}`);
        return res.data;
    },
    getSharedplanners: async (query: string): Promise<any> => {
        const res = await HTTP.get(`Location/GetSharedplanners${query ? "?" + query : ""}`);
        return res.data;
    },
    deleteplanner: (query: string): Promise<any> => {
        return HTTP.post(`Location/Deleteplanner${query ? "?" + query : ""}`);
    },
    getEditLocationLoadData: (query: string) => {
        return HTTP.get(`Location/EditLocation${query ? "?" + query : ""}`);
    },
    getEditLocationLoadDatapopup: (query: string) => {
        return HTTP.get(`Location/EditLocationpopup${query ? "?" + query : ""}`);
    },
    updateLocation: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<ILocationAddUpdateResult>(`Location/UpdateLocation${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getWardsWithSearch: (query: string) => {
        return HTTP.get(`Ward/GetWardsWithSearch${query ? "?" + query : ""}`);
    },
    getCustomerLocations: (query: string) => {
        return HTTP.get(`Booking/GetCustomerLocations${query ? "?" + query : ""}`);
    },
    getRecentlyUsedLocations: (query: string) => {
        return HTTP.get(`Booking/GetRecentlyUsedLocations${query ? "?" + query : ""}`);
    },
    addNewBooking: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post(`Booking/AddNewBooking${query ? "?" + query : ""}`, data);
        return res.data;
    },
    searchForBrands: async (query: string): Promise<any> => {
        return HTTP.get(`Medication/SearchForBrands${query ? "?" + query : ""}`);
    },
    getBrandMonograph: async (query: string): Promise<any> => {
        return HTTP.get(`Medication/GetBrandMonograph${query ? "?" + query : ""}`);
    },
    getBrandMonographDetails: async (query: string): Promise<any> => {
        return HTTP.get(`Medication/GetBrandMonographDetails${query ? "?" + query : ""}`);
    },
    getEditBooking: (query: string) => {
        return HTTP.get(`Booking/GetEditBooking${query ? "?" + query : ""}`);
    },
    updateBooking: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post(`Booking/UpdateBooking${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getSpecialNeeds: (query: string) => {
        return HTTP.get(`Booking/GetSpecialNeeds${query ? "?" + query : ""}`);
    },
    getPickUpDropOffReasons: (query: string) => {
        return HTTP.get(`Booking/GetPickUpDropOffReason${query ? "?" + query : ""}`);
    },
    isSMAAdmin: async (query: string) => {
        const res = await HTTP.get(`User/IsSMAAdmin${query ? "?" + query : ""}`);
        return res.data;
    },
    getWorkingHoursOfLocations: async (query: string) => {
        const res = await HTTP.get(`Location/GetWorkingHoursOfLocations${query ? "?" + query : ""}`);
        return res.data;
    },
    
    getUserLocation: async (query: string) => {
        const res = await HTTP.get(`User/GetUserLocation${query ? "?" + query : ""}`);
        return res.data;
    },
    getRoutes: (query: string) => {
        return HTTP.get(`Booking/GetRoutes${query ? "?" + query : ""}`);
    },
    getMeidcationAdministeredBy: (query: string) => {
        return HTTP.get(`Booking/GetAdministeredBy${query ? "?" + query : ""}`);
    },
    isSysAdmin: async (query: string) => {
        const res = await HTTP.get(`User/IsSysAdmin${query ? "?" + query : ""}`);
        return res.data;
    },
    getCurrentUserDetails: (query: string) => {
        return HTTP.get(`User/CurrentUserDetails${query ? "?" + query : ""}`);
    },
    GetUserPermission: async (query: string)=> {
        const res = await HTTP.post<any>(`User/GetUserPermission${query ? "?" + query : ""}`);
        return res.data;
       
    },
    getMedicationUnits: (query: string) => {
        return HTTP.get(`Booking/GetMedicationUnits${query ? "?" + query : ""}`);
    },
    updateMyUserDetails: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<IUserAddUpdateResult>(`User/UpdateMyUserDetails${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getScheduleList: (query: string, data: any) => {
        return HTTP.post(`Schedule/GetScheduleList${query ? "?" + query : ""}`, data);
    },
    requestEmailChangeUserPane: (query: string, data: any) => {
        return HTTP.post(`Schedule/RequestChangeEmail${query ? "?" + query : ""}`, data);
    },
    validateEmailChangeUserPane: (query: string, data: any) => {
        return HTTP.post(`Schedule/ValidateEmailConfirmationCode${query ? "?" + query : ""}`, data);
    },
    validateEmailUniqueUserPane: (query: string, data: any) => {
        return HTTP.post(`Schedule/ValidateEmailUnique${query ? "?" + query : ""}`, data);
    },
    addupdateReasonsForDelay: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post(`Reason/AddUpdateReasonsForDelay${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getReasonsForDelayPerUser: (query: string) => {
        return HTTP.get(`Reason/GetReasonsForDelay${query ? "?" + query : ""}`);
    },
    addupdateReasonsForCancellation: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post(`Reason/AddUpdateReasonsForCancellation${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getReasonsForCancellationPerUser: (query: string) => {
        return HTTP.get(`Reason/GetReasonsForCancellation${query ? "?" + query : ""}`);
    },
    changePasswordUserPane: async (query: string, data: any): Promise<IUserAddUpdateResult> => {
        const res = await HTTP.post<IUserAddUpdateResult>(`User/ChangePasswordUserPane${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getScheduleTransferDetails: async (query: string) => {
        const res = await HTTP.get(`Schedule/GetTransferDetails${query ? "?" + query : ""}`);
        return res.data;
    },
    updateScheduleTransferDetails: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Schedule/UpdateScheduleTransfer${query ? "?" + query : ""}`, data);
        return res.data;
    },
    cancelTransfer: async (query: string, data: any) => {
        // const res = await HTTP.post<any>(`Schedule/CancelTransfer${query ? "?" + query : ""}`);
        const res = await HTTP.post(`Schedule/CancelTransfer${query ? "?" + query : ""}`, data);
        return res.data;
    },
    assignJob: (query: string, data: any) => {
        return HTTP.post(`Schedule/AssignTransferToCurrentUser${query ? "?" + query : ""}`, data);
    },
    unassignJob: (query: string, data: any) => {
        return HTTP.post(`Schedule/UnassignTransferToCurrentUser${query ? "?" + query : ""}`, data);
    },
    isSMAUser: async (query: string) => {
        const res = await HTTP.get(`User/IsSMAUser${query ? "?" + query : ""}`);
        return res.data;
    },
    assignVehicleToDriver: async (query: string): Promise<any> => {
        const res = await HTTP.post<any>(`Auth/ChooseVehicle${query ? "?" + query : ""}`);
        return res.data;
    },
    getUserVehicleSession: async (query: string) => {
        const res = await HTTP.get(`Auth/GetMyVehicleSession${query ? "?" + query : ""}`);
        return res.data;
    },
    assignVehicleToTransfer: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Schedule/AssignVehicleToTransfer${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getNotifyingUsers: async (query: string) => {
        const res = await HTTP.get(`Schedule/GetNotifyingUsers${query ? "?" + query : ""}`);
        return res.data;
    },
    canStartAtrip: async (query: string) => {
        const res = await HTTP.get(`Trip/CanStartAtrip${query ? "?" + query : ""}`);
        return res.data;
    },
    checkTransferInProgress: async (query: string) => {
        const res = await HTTP.get(`Trip/CheckTransferInProgress${query ? "?" + query : ""}`);
        return res.data;
    },
    initTrip: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Trip/InitTrip${query ? "?" + query : ""}`, data);
        return res.data;
    }, 
    getTrip: async (query: string) => {
        const res = await HTTP.get(`Trip/GetTrip${query ? "?" + query : ""}`);
        return res.data;
    },
    updateTripStatus: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Trip/UpdateTripStatus${query ? "?" + query : ""}`, data);
        return res.data;
    },
    updateTransferStatus: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Trip/UpdateTransferStatus${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getMyLocationWeeklyWorkingHours: (query: string) => {
        return HTTP.get(`Location/GetMyLocationWeeklyWorkingHours${query ? "?" + query : ""}`);
    },
    getLocationWeeklyWorkingHours: (query: string) => {
        return HTTP.get(`Location/GeLocationWeeklyWorkingHours${query ? "?" + query : ""}`);
    },
    getMyWard: (query: string) => {
        return HTTP.get(`Ward/GetMyWard${query ? "?" + query : ""}`);
    },
    getTransferState: (query: string) => {
        return HTTP.get(`Schedule/GetTransferCurrentState${query ? "?" + query : ""}`);
    },
    getTripGetails: async (query: string) => {
        const res = await HTTP.get(`Trip/GetTripGetails${query ? "?" + query : ""}`);
        return res.data;
    },   
    trackWebFleetNearestVehicles: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Trip/TrackWebFleetNearestVehicles${query ? "?" + query : ""}`, data);
        return res.data;
    },
    TrackWebFleetNearestVehicle: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Trip/TrackWebFleetNearestVehicle${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getReasonsToAbort: (query: string) => {
        return HTTP.get(`Reason/GetReasonsToAbort${query ? "?" + query : ""}`);
    },
    getActiveTripDetails: async (query: string) => {
        const res = await HTTP.get(`Trip/GetActiveTripDetails${query ? "?" + query : ""}`);
        return res.data;
    }, 
    getTransferTotalStats: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post(`Dashboard/GetTransferTotalStats${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getTransfersPerformedStats: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post(`Dashboard/GetTransfersPerformedStats${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getReasonsForDelayStats: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post(`Dashboard/GetReasonsForDelayStats${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getTransportByWardStats: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Dashboard/GetTransportByWardStats${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getTopFiveDestinationsStats: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Dashboard/GetTopFiveDestinationsStats${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getTransportTimesByDayOfAWeekStats: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Dashboard/GetTransportTimesByDayOfAWeekStats${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getTransportByDayOfAWeekStats: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Dashboard/GetTransportByDayOfAWeekStats${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getTransferPerServiceDayStat: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Dashboard/GetTransferPerServiceDayStat${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getTransferPerServiceHourStat: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Dashboard/GetTransferPerServiceHourStat${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getTransferPickupDelayedStat: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Dashboard/GetTransferPickupDelayedStat${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getTransferDelayedStat: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Dashboard/GetTransferDelayedStat${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getTransferMultiLoadStat: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Dashboard/GetTransferMultiLoadStat${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getTransferDistanceStat: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Dashboard/GetTransferDistanceStat${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getTransferAttendingDoctorStat: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Dashboard/GetTransferAttendingDoctorStat${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getActivities: (query: string) => {
        return HTTP.get(`Activity/GetActivities${query ? "?" + query : ""}`);
    },
    getActivitiesByPage: (query: string) => {
        return HTTP.get(`Activity/GetActivitiesByPage${query ? "?" + query : ""}`);
    },
    getTransportsByWardHospital: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Dashboard/GetTransportsByWardHospital${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getNurseTransferList: (query: string, data: any) => {
        return HTTP.post(`NurseStation/getNurseTransferList${query ? "?" + query : ""}`, data);
    },
    getLocationForDashboardList: (query: string, data: any) => {
        return HTTP.post(`HQDisplay/GetLocationForDashboardList${query ? "?" + query : ""}`, data);
    },
    getLocationsCompletedTransfers: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post(`HQDisplay/GetLocationsCompletedTransfers${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getTransferStatusesStats: (query: string, data: any) => {
        return HTTP.post(`HQDisplay/GetTransferStatusesStats${query ? "?" + query : ""}`, data);
    },
    getDoctorNames: (query: string) => {
        return HTTP.get(`Booking/GetDoctorNames${query ? "?" + query : ""}`);
    },
    getDoctorPosition: (query: string) => {
        return HTTP.get(`Booking/GetDoctorPosition${query ? "?" + query : ""}`);
    },
    VehicleTrackingForNurseStation: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Trip/VehicleTrackingForNurseStation${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getAppPermissionCategories: async (query: string) => {
        return await HTTP.get(`User/GetApplicationPermissionCategories${query ? "?" + query : ""}`);
    },
    getLocationsForUserProfiles: (query: string) => {
        return HTTP.get(`User/GetLocationsForUserProfiles${query ? "?" + query : ""}`);
    },
    getWarnigmessage: (query: string) => {
        return HTTP.get(`User/GetWarnigmessage${query ? "?" + query : ""}`);
    },
    getUserProfiles: (query: string, data: any) => {
        return HTTP.post(`User/GetUserProfiles${query ? "?" + query : ""}`, data);
    },
    getUserProfilesmanageuser: (query: string, data: any) => {
        return HTTP.post(`User/GetUserProfilesManageuser${query ? "?" + query : ""}`, data);
    },
    getMyLocationUserList: (query: string) => {
        return HTTP.get(`User/GetMyLocationUserList${query ? "?" + query : ""}`);
    },
    addUpdateAppLocation: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`WrapperApp/AddUpdateAppLocation${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getMyObjectAccessPermission: async (tableName: string,  type: PermissionType): Promise<PermissionAccessLevel> => {
        const res = await HTTP.get<any>(`Permission/GetMyObjectPermission?tableName=${tableName}&type=${type}`);
        return res.data;
    },
    getProfilesByLocation: async (query: any, data: any): Promise<any> => {
        return await HTTP.get(`User/GetUserProfilesByLocation${query ? "?" + query : ""}`);     
    },
    getAddUserDataLocation: (query: string) => {
        return HTTP.get(`User/AddUserLocation${query ? "?" + query : ""}`);
    },
    getEditUserDataLocation: (query: string) => {
        return HTTP.get(`User/EditUserLocation${query ? "?" + query : ""}`);
    },
    addNewUserLocation: async (query: string, data: any): Promise<IUserAddUpdateResult> => {
        const res = await HTTP.post<IUserAddUpdateResult>(`User/AddNewUserLocation${query ? "?" + query : ""}`, data);
        return res.data;
    },
    updateUserLocation: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<IUserAddUpdateResult>(`User/UpdateUserLocation${query ? "?" + query : ""}`, data);
        return res.data;
    },
    addProfileLocation: async (query: string, data: any): Promise<IUserProfileAddUpdateResult> => {
        const res = await HTTP.post<IUserProfileAddUpdateResult>(`User/AddNewUserProfileLocation${query ? "?" + query : ""}`, data);
        return res.data;
    },  
    getLocationsForUserProfilesByLocation: (query: string) => {
        return HTTP.get(`User/GetLocationsForUserProfilesByLocation${query ? "?" + query : ""}`);
    },
    getProfilesByLocationUser: async (query: string, data: any): Promise<any> => {
        return await HTTP.get(`User/GetUserProfilesByLocationUser${query ? "?" + query : ""}`);
    },
    getTransferEditDetailSMA: async (query: string) => {
        const res = await HTTP.get(`Transfer/GetTransferEditDetailSMA${query ? "?" + query : ""}`);
        return res.data;
    },
    updateTransferDetailSMA: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Transfer/UpdateTransferDetailSMA${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getAuditEntries: (query: string) => {
        return HTTP.get(`Audit/GetAuditEntries${query ? "?" + query : ""}`);
    },
    getAuditEntriesByPage: (query: string) => {
        return HTTP.get(`Audit/GetAuditEntriesByPage${query ? "?" + query : ""}`);
    },
    getAuditEntryDetail: (query: string) => {
        return HTTP.get(`Audit/GetAuditEntryDetail${query ? "?" + query : ""}`);
    },
    deleteTransferSMA: (query: string) => {
        return HTTP.get(`Transfer/DeleteTransferSMA${query ? "?" + query : ""}`);
    },
    exportTransferToPdf: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Transfer/ExportTransferToPdf${query ? "?" + query : ""}`, data);
        return res.data;
    },
    changePasswordLocation: async (query: string, data: any): Promise<IUserAddUpdateResult> => {
        const res = await HTTP.post<IUserAddUpdateResult>(`User/ChangePasswordLocation${query ? "?" + query : ""}`, data);
        return res.data;
    },
    retreatTransfer: async (query: string) => {
        const res = await HTTP.post<any>(`Transfer/RetreatTransfer${query ? "?" + query : ""}`);
        return res.data;
    },
    isEmployeeIdUnique: async (query: string) => {
        const res = await HTTP.get(`User/IsEmployeeIdUnique${query ? "?" + query : ""}`);
        return res.data;
    },
    checkLoginSMS: async (query: string, data: any): Promise<ILoginResult> => {
        const res = await HTTP.post<ILoginResult>(`Auth/CheckLoginSMS${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getGlobalSettings: async (query: string) => {
        const res = await HTTP.get(`TripEstimator/GetGlobalSettings${query ? "?" + query : ""}`);
        return res.data;
    },
    setGlobalSettings: async (query: string, data: any) => {
        const res = await HTTP.post<ILoginResult>(`TripEstimator/SaveGlobalSettings${query ? "?" + query : ""}`, data);
        return res.data;
    },
    estimateTrip: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`TripEstimator/EstimateTrip${query ? "?" + query : ""}`, data);
        return res.data;
    },
    calculateRoute: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`TripEstimator/CalculateRoute${query ? "?" + query : ""}`, data);
        return res.data;
    },
    calculateTransferDuration: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`TripEstimator/CalculateTransferDuration${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getTransferHistoryList: (query: string, data: any) => {
        return HTTP.post(`Transfer/GetTransferHistoryList${query ? "?" + query : ""}`, data);
    },
    saveTransferExportUserSelection: (query: string, data: any) => {
        return HTTP.post(`Transfer/SaveTransferExportUserSelection${query ? "?" + query : ""}`, data);
    },
    destroyUserVehicleSession: (query: string, data: any) => {
        return HTTP.post(`User/DestroyUserVehicleSession${query ? "?" + query : ""}`, data);
    },
    getTransferCombinedStats: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post(`Dashboard/GetTransferCombinedStats${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getLocationClustersSearch: (query: string) => {
        return HTTP.get(`LocationCluster/GetLocationClustersWithSearch${query ? "?" + query : ""}`);
    },
    getLocationGroupedByClusters: (query: string) => {
        return HTTP.get(`LocationCluster/GetLocationsByClusters${query ? "?" + query : ""}`);
    },
    addLocationCluster: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<ILocationClusterAddUpdateResult>(`LocationCluster/AddLocationCluster${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getEditLocationCluster: (query: string) => {
        return HTTP.get(`LocationCluster/EditLocationCluster${query ? "?" + query : ""}`);
    },
    updateLocationCluster: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<ILocationClusterAddUpdateResult>(`LocationCluster/UpdateLocationCluster${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getLocationClusters: async (query: string) => {
        const res = await HTTP.get(`LocationCluster/GetLocationClusters${query ? "?" + query : ""}`);
        return res.data;
    },
    getRequestCalloutList: (query: string, data: any) => {
        return HTTP.post(`AgedCare/GetRequestCalloutList${query ? "?" + query : ""}`, data);
    },
    getCalloutLastRequestedDates: (query: string, data: any) => {
        return HTTP.post(`AgedCare/GetCalloutLastRequestedDates${query ? "?" + query : ""}`, data);
    },
    changeRequestCalloutType: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post(`AgedCare/ChangeRequestCalloutType${query ? "?" + query : ""}`, data);
        return res.data;
    },
    checkForExistingCallout: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`AgedCare/CheckForExistingCallout${query ? "?" + query : ""}`, data);
        return res.data;
    },
    addCalloutRequest: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`AgedCare/AddCalloutRequest${query ? "?" + query : ""}`, data);
        return res.data;
    },
    updateRequestCallout: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post(`AgedCare/UpdateRequestCallout${query ? "?" + query : ""}`, data);
        return res.data;
    },
    cancelRequestCallout: async (query: string, data: any) => {
        const res = await HTTP.post<any>(`AgedCare/CancelRequestCallout${query ? "?" + query : ""}`, data);
        return res.data;
    },
    undoRequestCallout: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post(`AgedCare/UndoRequestCallout${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getRequestCalloutDetails: async (query: string) => {
        const res = await HTTP.get(`AgedCare/GetRequestCalloutDetails${query ? "?" + query : ""}`);
        return res.data;
    },
    updateRequestCalloutEvent: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post(`AgedCare/UpdateRequestCalloutEvent${query ? "?" + query : ""}`, data);
        return res.data;
    },
    assignVehicleShiftClusterToDriver: async (query: string): Promise<any> => {
        const res = await HTTP.post<any>(`Auth/ChooseVehicleShiftCluster${query ? "?" + query : ""}`);
        return res.data;
    },
    addCalloutRequestFeedack: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`AgedCare/AddCalloutRequestFeedack${query ? "?" + query : ""}`, data);
        return res.data;
    },
    assignCalloutRequestToUser: (query: string, data: any) => {
        return HTTP.post(`AgedCare/AssignCalloutRequestToUser${query ? "?" + query : ""}`, data);
    },
    assignCalloutRequestToVehicle: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`AgedCare/AssignCalloutRequestToVehicle${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getReasonsForCalloutUser: (query: string) => {
        return HTTP.get(`Reason/GetReasonsForCalloutUser${query ? "?" + query : ""}`);
    },
    addUpdateReasonsForCallout: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post(`Reason/AddUpdateReasonsForCallout${query ? "?" + query : ""}`, data);
        return res.data;
    },    
    trackCalloutRequestVehicle: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`AgedCare/TrackCalloutRequestVehicle${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getCalloutCombinedStats: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post(`AgedCareDashboard/GetCalloutCombinedStats${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getCalloutPerServiceDayStat: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`AgedCareDashboard/GetCalloutPerServiceDayStat${query ? "?" + query : ""}`, data);
        return res.data;
    },
    addEventShift: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`EventShift/AddEventShift${query ? "?" + query : ""}`, data);
        return res.data;
    },
    startEventShift: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`EventShift/StartEventShift${query ? "?" + query : ""}`, data);
        return res.data;
    },
    updateEventShift: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`EventShift/UpdateEventShift${query ? "?" + query : ""}`, data);
        return res.data;
    },
    updateEventShiftStatus: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`EventShift/UpdateEventShiftStatus${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getEventShiftDetails: async (query: string) => {
        const res = await HTTP.get(`EventShift/GetEventShiftDetails${query ? "?" + query : ""}`);
        return res.data;
    },
    startHealthshareShift: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`HealthshareShift/StartHealthshareShift${query ? "?" + query : ""}`, data);
        return res.data;
    },
    endHealthshareShift: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`HealthshareShift/EndHealthshareShift${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getHealthshareShiftDetails: async (query: string) => {
        const res = await HTTP.get(`HealthshareShift/GetHealthshareShiftDetails${query ? "?" + query : ""}`);
        return res.data;
    },
    hasDashboardLocations: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post(`Dashboard/HasDashboardLocations${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getVehicleShiftsStats: (query: string, data: any) => {
        return HTTP.post(`HQDisplay/GetVehicleShiftsStats${query ? "?" + query : ""}`, data);
    },
    getActiveEventShiftDetails: async (query: string) => {
        const res = await HTTP.get(`EventShift/GetActiveEventShiftDetails${query ? "?" + query : ""}`);
        return res.data;
    },
    getActiveHealthShareShiftDetails: async (query: string) => {
        const res = await HTTP.get(`HealthshareShift/GetActiveHealthShareShiftDetails${query ? "?" + query : ""}`);
        return res.data;
    },
    removeTripPlanner: async (query: string) => {
        const res = await HTTP.get<any>(`TripPlanner/RemoveTripPlanner${query ? "?" + query : ""}`);
        return res.data;
    },
    getLocationTripPlanners: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post(`TripPlanner/GetLocationTripPlanners${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getPlannerByLocation: async (query: string): Promise<any> => {
        const res = await HTTP.get(`Location/GetPlannerByLocation${query ? "?" + query : ""}`);
        return res.data;
    },
    requestAdHocTransfer: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Transfer/RequestAdHocTransfer${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getAdHocTransferDetails: async (query: string) => {
        const res = await HTTP.post(`Transfer/GetAdHocTransferDetails${query ? "?" + query : ""}`);
        return res.data;
    },
    addTransferToTripPlanner: async (query: string, data: any) => {
        const res = await HTTP.post<any>(`TripPlanner/AddTransferToTripPlanner${query ? "?" + query : ""}`, data);
        return res.data;
    },
    removeTransferFromTripPlanner: async (query: string) => {
        const res = await HTTP.post<any>(`TripPlanner/RemoveTransferFromTripPlanner${query ? "?" + query : ""}`);
        return res.data;
    },
    batchSaveScheduler: async (query: string, data: any) => {
        const res = await HTTP.post<any>(`TripPlanner/BatchSaveScheduler${query ? "?" + query : ""}`, data);
        return res.data;
    },
    estimateVirtualTrip: async (query: string, data: any) => {
        const res = await HTTP.post<any>(`TripPlanner/EstimateVirtualTrip${query ? "?" + query : ""}`, data);
        return res.data;
    },
    cancelAdHocRequest: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Transfer/CancelAdHocRequest${query ? "?" + query : ""}`, data);
        return res.data;
    },
    removeTripFromPlanner: async (query: string) => {
        const res = await HTTP.post<any>(`TripPlanner/RemoveTripFromPlanner${query ? "?" + query : ""}`);
        return res.data;
    },
    getTransferPerServiceDayTotalStat: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Dashboard/GetTransferPerServiceDayTotalStat${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getTransferPerServiceHourTotalStat: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Dashboard/GetTransferPerServiceHourTotalStat${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getReasonsForWaitTimeUser: (query: string) => {
        return HTTP.get(`Reason/GetReasonsForWaitTimeUser${query ? "?" + query : ""}`);
    },
    addUpdateReasonsForWaitTime: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post(`Reason/AddUpdateReasonsForWaitTime${query ? "?" + query : ""}`, data);
        return res.data;
    },
    startWaitTimer: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Transfer/StartWaitTimer${query ? "?" + query : ""}`, data);
        return res.data;
    },
    stopWaitTimer: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Transfer/StopWaitTimer${query ? "?" + query : ""}`, data);
        return res.data;
    },
    cancelWaitTimer: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Transfer/CancelWaitTimer${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getWaitTimeDetails: async (query: string, data: any) => {
        const res = await HTTP.post(`Transfer/GetWaitTimeDetails${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getActiveWaitTimeCaptures: async (query: string, data: any) => {
        const res = await HTTP.post(`Transfer/GetActiveWaitTimeCaptures${query ? "?" + query : ""}`, data);
        return res.data;
    },
    resumeTrip: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Trip/ResumeTrip${query ? "?" + query : ""}`, data);
        return res.data;
    },
    scheduleAdHocTransfer: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Schedule/ScheduleAdHocTransfer${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getVehiclesBases: (query: string) => {
        return HTTP.get(`Vehicle/GetVehiclesBases${query ? "?customerId=" + query : ""}`);
    },
    getVehicle: (query: string) => {
        return HTTP.get(`Vehicle/GetVehicle${query ? "?" + query : ""}`);
    },
    getVehicles: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Vehicle/GetVehicles${query ? "?" + query : ""}`, data);
        return res.data;
    },
    addVehicle: async (query: string, data: any): Promise<IVehicleAddUpdateResult> => {
        const res = await HTTP.post<IVehicleAddUpdateResult>(`Vehicle/AddVehicle${query ? "?" + query : ""}`, data);
        return res.data;
    },
    updateVehicle: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<IVehicleAddUpdateResult>(`Vehicle/UpdateVehicle${query ? "?" + query : ""}`, data);
        return res.data;
    },
    generateEmrPocPdf: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`EmrPoc/GenerateEmrPocPdf${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getTransferHistoryListByPage: (query: string, data: any) => {
        return HTTP.post(`Transfer/GetTransferHistoryListByPage${query ? "?" + query : ""}`, data);
    },
    //pcr
    addNewBookingPCR: async (query: string, data: any): Promise<any> => {   
        const res = await HTTP.post(`PCR/AddNewBooking${query ? "?" + query : ""}`, data);
        return res.data;
	},
	
    getInflationUplift:  (query: string): Promise<any> => {
        return HTTP.post<any>(`InflationUplift/AddNewInflationUplift${query ? "?" + query : ""}`);
    },
   
    getAllUplifts: async (query: string) => {
        return await HTTP.get(`InflationUplift/GetAllUplifts${query ? "?" + query : ""}`);
    },

    getDeletUplifts:  (query: string): Promise<any> => {
        return HTTP.post<any>(`InflationUplift/DeleteInflation${query ? "?" + query : ""}`);
    },
    GetUTCdatetimefromlocationtimezone: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Transfer/GetUTCdatetimefromlocationtimezone${query ? "?" + query : ""}`, data);
    },
    downloadBookingPCR: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post(`PCR/DownloadBooking${query ? "?" + query : ""}`, data);
        return res.data;
    },
    downloadfile: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.get(`PCR/DownloadFile${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getFleetOfCustomerList: () => {
        return HTTP.get(`Vehicle/GetFleetOfCustomerList`);
    },
    getCustomerVehiclesBases: (query: string|undefined) => {
        return HTTP.get(`Vehicle/GetCustomerVehiclesBases${query ? "?locationId=" + query : ""}`);
    },
    initializeNewVehicle: (query: string|undefined) => {
        return HTTP.get(`Vehicle/InitializeNewVehicle${query ? query : ""}`);
    },
    getVehiclesBasedOnCustomer: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Vehicle/GetVehiclesBasedOnCustomer${query ? "?" + query : ""}`, data);
        return res.data;
    },
    GetPublicHolidayList: async (query: string): Promise<any> => {
        const res = await HTTP.get(`Location/GetPublicHolidayList${query ? "?" + query : ""}`);
        return res.data;
    },
    searchPCRByNameCount: (query: string) => {
        return HTTP.get(`PCR/GetPCRWithSearchCount${query ? "?" + query : ""}`);
    },
    searchPCRByName: (query: string) => {
        return HTTP.get(`PCR/GetPCRWithSearch${query ? "?" + query : ""}`);
    },
    ImportFilePdf: (query: string, data: any) => {
        return HTTP.post(`PCR/ImportFilePdf${query ? "?" + query : ""}`,data);
    },

    checkDbStorageConnection: (query: any) => {
        return HTTP.get(`Auth/checkconnection${query ? "?" + query : ""}`);
    },
    getuser: async (query: string) => {
        const res = await HTTP.get(`Auth/GetSmaDrivers${query ? "?" + query : ""}`);
        return res.data;
    },
    createsession: async (query: string) => {
        const res = await HTTP.post(`Auth/Getmessagevalidation${query ? "?" + query : ""}`);
        return res.data;
    },
    createemail: async (query: string) => {
        const res = await HTTP.post(`Auth/Getemailvalidation${query ? "?" + query : ""}`);
        return res.data;
    },
    updateemail: async (query: string) => {
        const res = await HTTP.post(`Auth/Updateemailvalidation${query ? "?" + query : ""}`);
        return res.data;
    },
    deletemember: async (query: string) => {
        const res = await HTTP.post(`Auth/DeleteTeammember${query ? "?" + query : ""}`);
        return res.data;
    },
    GetTeammembers: async (query: string) => {
        const res = await HTTP.get(`Auth/GetTeammembers${query ? "?" + query : ""}`);
        return res.data;
    },
    GetFullActiveTeammembers: async (query: string) => {
        const res = await HTTP.get(`Auth/GetFullActiveTeammembers${query ? "?" + query : ""}`);
        return res.data;
    },
    downloadpcr: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post(`PCR/DownloadPCR${query ? "?" + query : ""}`, data);
        return res.data;
	},
    downloadpcrfile: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.get(`PCR/DownloadFileURL${query ? "?" + query : ""}`, data);
        return res.data;
	},
    getPCRReviewNotes: (query: string) => {
        return HTTP.get(`PCR/GetPCRReviewNotes${query ? "?" + query : ""}`);
    },
    addPCRReviewNotes:async (query: string, data: any): Promise<any> => {
        const res =await HTTP.post<any>(`PCR/AddPCRReviewNotes${query ? "?" + query : ""}`,data);
        return res.data;
    },
    updatePCRReviewNotes:async (query: string, data: any): Promise<any> => {
        const res =await HTTP.post<any>(`PCR/UpdatePCRReviewNotes${query ? "?" + query : ""}`,data);
        return res.data;
    },
    updateaccesscode: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post(`PCR/UpdateAccesscode${query ? "?" + query : ""}`, data);
        return res.data;
	},
    getPCRCustomers: (query: string) => {
        return HTTP.get(`PCR/GetCustomers${query ? "?" + query : ""}`);
    },
    getEditBookingPCR: (query: string) => {
        return HTTP.get(`PCR/GetEditBooking${query ? "?" + query : ""}`);
    },
    getPCRCustomer: async(query: string,data: any): Promise<any> => {
        const res = await HTTP.get(`PCR/GetCustomer${query ? "?" + query : ""}`,data);
        return res.data;
    },
    getCareGiversList: async (query: string) => {
        const res = await HTTP.get(`PCR/GetPCRCareGivers${query ? "?" + query : ""}`);
        return res.data;
    },
    pushFileToBlobStorage: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`PCR/pushFileToBlobStorage${query ? "?" + query : ""}`, data);
        return res.data;
    },
    isCustomerLocationExist: (query: string) => {
        return HTTP.get(`Booking/IsCustomerLocationExist${query ? "?" + query : ""}`);
    },
    //Customerprivileges
    getCustomerForUserProfiles: (query: string) => {
        return HTTP.get(`User/GetCustomersForUserProfiles${query ? "?" + query : ""}`);
    },
    getCustomerGroupedByClusters: (query: string) => {
        return HTTP.get(`Customer/GetCustomerByUser${query ? "?" + query : ""}`);
    },
    getwardbyuserprofile:async (query: string): Promise<any>  => {
        const res = await HTTP.get(`User/Getwardbyuserprofile${query ? "?" + query : ""}`);
        return res.data;
    },
    getwardbyCustomer: (query: string) => {
        return HTTP.get(`Ward/GetwardbyCustomer${query ? "?" + query : ""}`);
    },
    getwardbyLocation: () => {
        return HTTP.get(`Ward/GetwardbyLocationlst`);
    },
    updateactivationcode:async (query: string): Promise<any>  => {
        const res = await HTTP.post(`User/NursestationDashboardActivation${query ? "?" + query : ""}`);
        return res.data;
    },
    getVechicles: async (query: string): Promise<any> => {
        const res = await HTTP.post(`Vehicle/GetVechiclesByCustomer${query ? "?" + query : ""}`);
        return res.data;
	},
    AddOverrideMinutestoTransfers:async (query: string,data:any): Promise<any>  => {
        const res = await HTTP.post(`TripEstimator/AddOverrideMinutestoTransfers${query ? "?" + query : ""}`, data);
        return res.data;
    },
    GetOverrideMinutestoTransfers: async (query: string,data:any) => {
        const res = await HTTP.post(`TripEstimator/GetOverrideMinutestoTransfers${query ? "?" + query : ""}`, data);
        return res.data;
    },
    checkRules:async (query: string): Promise<any>  => {
        const res = await HTTP.post(`Customer/CheckDecisionRule${query ? "?" + query : ""}`);
        return res.data;
    },
    getCustomer: (query: string) => {
        return HTTP.get(`Trip/GetCustomers${query ? "?" + query : ""}`);
    },
    updateRepricing: async (query: string) : Promise<any>=> {
        const res = await HTTP.post(`Trip/updateRepricing${query ? "?" + query : ""}`);
        return res.data;
    },
    searchErrorLog: (query: string) => {
        return HTTP.get(`Trip/GetErrorLog${query ? "?" + query : ""}`);
    },
    AddErrortoErrorLog: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`Auth/AddErrortoErrorLog${query ? "?" + query : ""}`, data);
        return res.data;
    },
    GetObservationData: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post<any>(`PCR/GetObservationDate${query ? "?" + query : ""}`, data);
        return res.data;
    },
    CheckChartPDFExist: async (query: string, data: any): Promise<any> => {
        const res = await HTTP.post(`PCR/CheckChartPDFExists${query ? "?" + query : ""}`, data);
        return res.data;
    },
    UpdateETA: async (query: string, data: any) => {
        const res = await HTTP.post<any>(`Schedule/UpdateETA${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getReasonForReschedule: (query: any) => {
        return HTTP.get(`ReasonForReschedule/GetReasonForReschedule${query ? "?" + query : ""}`);
    },
    UpdateRescheduledReasonOnSaveChanges: async (query: string, data: any) => {
        const res = await HTTP.post<any>(`Schedule/UpdateRescheduledReasonOnSaveChanges${query ? "?" + query : ""}`, data);
        return res.data;
    },
    getReasonForRescheduleSearch:async (query: string, data: any) => {
        const res = await HTTP.post<any>(`ReasonForReschedule/GetReasonForRescheduleWithSearch${query ? "?" + query : ""}`, data);
        return res.data;
    },
    UpdateReasonForReschedule:async (query: string, data: any) => {
        const res = await HTTP.post<any>(`ReasonForReschedule/UpdateReasonForReschedule${query ? "?" + query : ""}`, data);
        return res.data;
    },
    GetReasonForReschedulebyId: (query: any) => {
        return HTTP.get(`ReasonForReschedule/GetReasonForReschedulebyId${query ? "?" + query : ""}`);
    },
    AddNewReasonForReschedule:async (query: string, data: any) => {
        const res = await HTTP.post<any>(`ReasonForReschedule/AddNewReasonForReschedule${query ? "?" + query : ""}`, data);
        return res.data;
    },
    DeleteReasonForReschedule:async (query: string, data: any) => {
        const res = await HTTP.post<any>(`ReasonForReschedule/DeleteReasonForReschedule${query ? "?" + query : ""}`, data);
        return res.data;
    },

}